export const TABS = [
    { key: 'recipes', title: 'Рецепты', icon: 'flaticon2-open-text-book' },
    { key: 'goods', title: 'Используется в товарах', icon: 'flaticon2-layers' },
    { key: 'semi', title: 'Используется в полуфабрикатах', icon: 'flaticon2-delivery-package' },
];